/**
     * LocationChanged.contract.ts — Event Contract System™ (generation v1).
     * The operator's Current Base changed. The single location pipeline: Location Engine → builtin adapter → bus. Triggers the full base-change workflow (fusion refresh, intelligence recalc, module refreshes).
     */

    import type { EventContract } from '../EventContractRegistry';

    export const LocationChangedContract: EventContract = {
      name: 'LocationChanged',
      version: 1,
      description: "The operator's Current Base changed. The single location pipeline: Location Engine → builtin adapter → bus. Triggers the full base-change workflow (fusion refresh, intelligence recalc, module refreshes).",
      publishers: ["location"],
      subscribers: ["core:state-sync","core:location-workflow","module:stay","module:planner","module:connect","module:network","module:health","module:marketplace","module:visa","module:passport","sidebar"],
      fields: [
        { name: 'location', type: 'object', required: true, description: "The new RoamerLocation (locationId, city, country, latitude, longitude, …)" },
      ],
      allowExtraFields: false,
      timestampPolicy: "Set by the bridge at forward time (nowFn()) — wall-clock ms of the base change.",
      stability: 'stable',
      deprecated: false,
      example: {"location":{"locationId":"lisbon","city":"Lisbon","country":"Portugal","latitude":38.7223,"longitude":-9.1393}},
    };
    